import MedicationDosage from './MedicationDosage.jsx';

export default MedicationDosage;